/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetScripts200Response
 */
export interface GetScripts200Response {
    /**
     * 
     * @type {string}
     * @memberof GetScripts200Response
     */
    googleAnalyticsId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetScripts200Response
     */
    facebookAnalyticsId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetScripts200Response
     */
    googleTagManagerId?: string;
}

/**
 * Check if a given object implements the GetScripts200Response interface.
 */
export function instanceOfGetScripts200Response(value: object): value is GetScripts200Response {
    return true;
}

export function GetScripts200ResponseFromJSON(json: any): GetScripts200Response {
    return GetScripts200ResponseFromJSONTyped(json, false);
}

export function GetScripts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetScripts200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'googleAnalyticsId': json['googleAnalyticsId'] == null ? undefined : json['googleAnalyticsId'],
        'facebookAnalyticsId': json['facebookAnalyticsId'] == null ? undefined : json['facebookAnalyticsId'],
        'googleTagManagerId': json['googleTagManagerId'] == null ? undefined : json['googleTagManagerId'],
    };
}

export function GetScripts200ResponseToJSON(json: any): GetScripts200Response {
    return GetScripts200ResponseToJSONTyped(json, false);
}

export function GetScripts200ResponseToJSONTyped(value?: GetScripts200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'googleAnalyticsId': value['googleAnalyticsId'],
        'facebookAnalyticsId': value['facebookAnalyticsId'],
        'googleTagManagerId': value['googleTagManagerId'],
    };
}

